import React, { useState, useEffect } from "react";
import "./UserProfile.scss";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import { Scrollbars } from "react-custom-scrollbars";
import Api from "../../Common/api.jsx";
import MetaMaskService from "../../Common/metamaskService.jsx";
import { Navigate, Link } from "react-router-dom";
import DateHelper from "../../Helpers/DateHelper.jsx";
import { InlineShareButtons } from "sharethis-reactjs";
import CommonHelper from "../../Helpers/CommonHelper.jsx";
import SkeletonProduct,{Row} from "../../Pages/Skeleton/index.jsx";
//import {Row} from "../../Pages/Skeleton/index.jsx";

export default class UserProfile extends React.Component {
  constructor(props) {
    super(props);
    this.timeout = 0;
    this.timeout1 = 0;
    this.state = {
      filter: "",
      loader: false,
      loader1:false,
      loader2:false,
      loader3:false,
      user: {},
      userUpdateProfileArray: [],
      createAssetTab1: [],
      asset_id: null,
      tabId: 1,
      id: null,
      user_name: null,
      bio: null,
      custom_url: null,
      twitter_profile: null,
      personal_website: null,
      profile_picture: null,
      banner_picture: null,
      email: null,
      account: null,
      isOwnAccount: false,
      isInvalidAccount: false,
      collectionActivities: [],
      chainConfigs: [],
      numberOfRows : 5
    };
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    window.addEventListener("click", () => {
      if (document.getElementsByClassName("search-autocomplete")) {
        document.getElementsByClassName(
          "search-autocomplete"
        )[0].style.display = "none";
      }
    });
    const search = window.location.search;
    const params = new URLSearchParams(search);
    var account = params.get("account");
    let accountloc = localStorage.getItem("accountId");
    if (!account) {
      account = await new MetaMaskService().getAccount();

      if (!account) {
        //return to login page
        this.setState({ isInvalidAccount: true });
      }

      if (account) {
        this.setState({ isOwnAccount: true });
        this.setState({ account: accountloc });
      }
    } else {
      let loggedInAccount = await new MetaMaskService().getAccount();

      if (
        loggedInAccount &&
        account.toLocaleLowerCase() === loggedInAccount.toLocaleLowerCase()
      )
        this.setState({ isOwnAccount: true });
    }
    this.setState({ account: account }, () => {
      this.getChainConfigs();
      this.getUserProfile(this.state.account);
      this.createdAssetTab1(this.state.account, 1);
    });
  }

  getChainConfigs() {
    const chainConfigs = new CommonHelper().getAllChainConfigs();
    this.setState({ chainConfigs: chainConfigs });
  }

  getUserProfile(account) {
    const api = new Api();
    this.setState({loader1: true});
    var parameter = "";

   // this.timeout = setTimeout(() => {
    api
      .get("get_user/?account=" + account)
      .then((response) => {
        this.setState({ user: response.data });
        setTimeout(() => {
        this.setState({loader1: false});
        },1000);
        //clearTimeout(this.timeout);
      })
      .catch((err) => console.log(err));
   // }, 1000000);
  }

  createdAssetTab1(act, i) {
    this.setState({ tabId: i, createAssetTab1: [] });
    this.setState({ loader3: false });
    this.setState({ loader: false });

    const api = new Api();
    var parameter = "get_user_assets/?account=" + this.state.account;
    if (i == 1) {
      this.setState({ loader: true });
      parameter = "get_user_collected_assets/?account=" + this.state.account;
    } else if (i == 2) {
      this.setState({ loader: true });
      parameter = "get_user_collections/?account=" + this.state.account;
    } else if (i == 3) {
      this.setState({ loader: true });
      parameter = "get_user_assets/?account=" + this.state.account;
    } else if (i == 4) {
      parameter = "get_user_activities/?user_id=" + this.state.user.user_id;
      this.setState({ loader3: true });
    }

    // if (this.timeout1) clearTimeout(this.timeout1);
    // this.timeout1 = setTimeout(() => {
      api
        .get(parameter)
        .then((response) => {
          console.log(response.data);
          this.setState({ createAssetTab1: response.data });
          if (i == 1 || i==2 || i==3) {
            this.setState({ loader: false });
          }else if (i == 4) {
            this.setState({ loader3: false });
          }
        })
        .catch((err) => console.log(err));
    // }, 1000000);
  }

  getFormattedDateTime(date) {
    if (date) return new DateHelper().getFormattedDateTime(date);

    return "";
  }

  getIcon(event_type) {
    return new CommonHelper().getIcon(event_type);
  }

  getTransactionLink(chain_id, transaction_hash) {
    if (!this.state.chainConfigs) return "";

    var chainConfig = this.state.chainConfigs[chain_id];

    return chainConfig
      ? `${chainConfig.BLOCK_EXPLORER_URL}/tx/${transaction_hash}`
      : "";
  }

  render = () => {
    if (this.state.isInvalidAccount) {
      return <Navigate to={"/login"} />;
    }
    return (
      <>
        <Header />
        <div className="container">
          <section className="user-profile">
            <section className="user-board">
              <div className="user-board__data-banner">
              {!this.state.loader1 ? (
                <img
                  className="user-board__imgbanner"
                  src={
                    this.state.user?.banner_picture
                      ? this.state.user.banner_picture
                      : "../images/default_banner.png"
                  }
                  alt=""
                />
                ) :  [1].map(loading =>(
                  <>
                    <div className="skeleton-items1" key={loading}>
                    <SkeletonProduct />
                    </div>
                  </>
                ))}
              </div>
              <div className="user-board__data">
                <div className="container">
                  <div className="user-board__data-img">
                  {!this.state.loader1 ? (
                    <img
                      className="user-board__img"
                      src={
                        this.state.user?.profile_picture
                          ? this.state.user.profile_picture
                          : "../images/default_image.png"
                      }
                      alt=""
                    />
                    ) :  [1].map(loading =>(
                  <>
                    <div className="skeleton-items1" key={loading}>
                    <SkeletonProduct />
                    </div>
                  </>
                ))}
                  </div>
                  <div className="user-board__data-ttl">
                    <h1>
                      {this.state.user.user_name}{" "}
                      {this.state.user.is_user_verified ? (
                        <img src="../images/verify.png" alt="eth" />
                      ) : (
                        <></>
                      )}
                    </h1>
                    <div className="user-board__data-ttl_right">
                      {this.state.isOwnAccount && this.state.account ? (
                        <button className="button btn-edit-profile">
                          <Link to={"../EditProfile"}>
                            <img src="../images/svg/edit.svg" alt="" /> Edit
                            Profile{" "}
                          </Link>
                        </button>
                      ) : (
                        <></>
                      )}

                      <ul className="info-share">
                        <li>
                          {/* <a href="/">
                              <i className="material-icons-outlined">share</i>
                            </a> */}
                          <div style={{ "z-index": 0 }}>
                            <InlineShareButtons
                              config={{
                                alignment: "center", // alignment of buttons (left, center, right)
                                color: "social", // set the color of buttons (social, white)
                                enabled: true, // show/hide buttons (true, false)
                                font_size: 16, // font size for the buttons
                                labels: null, // button labels (cta, counts, null)
                                language: "en", // which language to use (see LANGUAGES)
                                networks: [
                                  // which networks to include (see SHARING NETWORKS)
                                  "whatsapp",
                                  "linkedin",
                                  "facebook",
                                  "twitter",
                                  "messenger",
                                ],
                                padding: 12, // padding within buttons (INTEGER)
                                radius: 4, // the corner radius on each button (INTEGER)
                                // show_total: true,
                                size: 40, // the size of each button (INTEGER)

                                // OPTIONAL PARAMETERS
                                url: window.location.href, // (defaults to current url)
                                image: this.state.profile_picture, // (defaults to og:image or twitter:image)
                                description: "", // (defaults to og:description or twitter:description)
                                title: this.state.user_name, // (defaults to og:title or twitter:title)
                                message: "custom email text", // (only for email sharing)
                                subject: "custom email subject", // (only for email sharing)
                                username: "custom twitter handle", // (only for twitter sharing)
                              }}
                            />
                          </div>
                        </li>
                        <li>
                          <a>
                            <i className="material-icons-outlined">
                              assistant_photo
                            </i>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="date-price">
                      {this.state.user.email}
                      {/* <span>{this.state.user.bio}</span> */}
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div className="exploreCollections">
              <div className="container">
                <div className="filter-wrap">
                  <ul className="filter-list">
                    <li>
                      {" "}
                      <a
                        className={this.state.tabId == 1 ? "active" : ""}
                        onClick={() => this.createdAssetTab1("", 1)}
                      >
                        Collected
                      </a>{" "}
                    </li>
                    <li>
                      {" "}
                      <a
                        className={this.state.tabId == 2 ? "active" : ""}
                        onClick={() => this.createdAssetTab1("", 2)}
                      >
                        Collections
                      </a>{" "}
                    </li>
                    <li>
                      {" "}
                      <a
                        className={this.state.tabId == 3 ? "active" : ""}
                        onClick={() => this.createdAssetTab1("", 3)}
                      >
                        Items
                      </a>{" "}
                    </li>
                    {/* <li>
                    {" "}
                    <a href="/">Favourited</a>{" "}
                  </li> */}
                    <li>
                      {" "}
                      <a
                        className={this.state.tabId == 4 ? "active" : ""}
                        onClick={() => this.createdAssetTab1("", 4)}
                      >
                        Activity
                      </a>{" "}
                    </li>
                    {/* <li>
                    {" "}
                    <a href="/">Offers Made</a>{" "}
                  </li>
                  <li>
                    {" "}
                    <a href="/">Offers Received</a>{" "}
                  </li> */}
                  </ul>
                  <div className="filter-wrap__btns">
                    {/* <button
                    className="filter-button" //onClick={() => setFilter(!filter)}
                  >
                    <div className="img-box">
                      <i className="material-icons-outlined">filter_list</i>
                    </div>
                    <span>Show Filters</span>
                  </button> */}
                    {/* <button className="filter-button">
                    <div className="img-box">
                      <i className="material-icons-outlined">sort</i>
                    </div>
                    <span>Sort</span>
                  </button> */}
                  </div>
                  {/* <div className="filter-wrap__search">
                  <form className="filter-wrap__search-box">
                    <input
                      type="text"
                      className="input"
                      placeholder="Search by name or trait"
                    />
                    <button type="button">
                      <img src="../images/search.png" alt="Search" />
                    </button>
                  </form>
                </div> */}
                </div>
                <div className="filter-list-box-wrap">
                  {!this.state.loader ? (
                    this.state.createAssetTab1?.length > 0  ?
                    <ul className="explore-nfts collection-details">
                      {this.state.createAssetTab1.map((explores) => (
                        <li
                          style={{
                            display: this.state.tabId == 1 ? "block" : "none",
                          }}
                        >
                          <Link
                            to={"../NftDetails/?assetId=" + explores.asset_id}
                            className="card"
                          >
                            <div className="card-img">
                              <img src={explores.asset_image} alt="discover" />
                            </div>
                            <div className="card-body">
                              <div className="artist-block">
                                <div className="media">
                                  <div className="media-body">
                                    <div className="media-body__left">
                                      <label>{explores.asset_name}</label>
                                    </div>
                                    <div className="media-body__right">
                                      {explores.price ? (
                                        <label>
                                          <span>Last</span>{" "}
                                          <img
                                            src={explores.currency_image}
                                            alt="eth"
                                          />{" "}
                                          {explores.price}
                                        </label>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </li>
                      ))}
                    </ul>
                     :
                     <>
                       <div className="no-items" style={{display:this.state.tabId ==1 ? "block":"none"}}> 
                         <span>No Items</span>
                       </div>
                     </>
                  ) : (
                    [1, 2, 3, 4].map((loading) => (
                      <>
                        <div className="skeleton-items" key={loading}>
                          <SkeletonProduct />
                        </div>
                      </>
                    ))
                  )}
                  {/* ====================================
                          COLLECTIONS
              ==================================== */}
                  {!this.state.loader ? (
                    this.state.createAssetTab1?.length > 0  ?
                    <ul className="explore-nfts">
                      {this.state.createAssetTab1.map((collection) => (
                        <li
                          style={{
                            display: this.state.tabId == 2 ? "block" : "none",
                          }}
                        >
                          <Link
                            to={
                              "../CollectionDetails/?collectionId=" +
                              collection.collection_id
                            }
                            className="card"
                          >
                            <div className="card-img">
                              <img
                                src={
                                  collection.collection_image
                                    ? collection.collection_image
                                    : "../images/card1.png"
                                }
                                alt="discover"
                              />
                              {/* <div className="price">
                            <img src="../images/eth.png" alt="price" /> 0.25
                          </div> */}
                            </div>
                            <div className="card-body">
                              <div className="artist-block">
                                <div className="media">
                                  <div className="media-img">
                                    <img
                                      src={collection.profile_image}
                                      alt="artist block"
                                    />
                                  </div>
                                  <div className="media-body">
                                    <h4 title={collection.collection_name}>
                                      {/* The Futr Abstr{" "} */}
                                      <label
                                        style={{
                                          width: 120 + "px",
                                          whiteSpace: "nowrap",
                                          overflow: " hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        {collection.collection_name}
                                      </label>
                                      {/* <div className="img-box">
                                      <img
                                        src="../images/verify.png"
                                        alt="verify"
                                      />
                                    </div> */}
                                    </h4>
                                  </div>
                                  {/* <div className="bid-count"></div> */}
                                </div>
                              </div>
                            </div>
                          </Link>
                        </li>
                      ))}
                    </ul>
                     :
                     <>
                       <div className="no-items" style={{display:this.state.tabId ==2 ? "block":"none"}}> 
                         <span>No Items</span>
                       </div>
                     </>
                  ) : (
                    [1].map((loading) => (
                      <>
                        <div className="skeleton-items" key={loading}>
                          <SkeletonProduct />
                        </div>
                      </>
                    ))
                  )}
                  {/* ====================================
                          ITEMS
              ==================================== */}
                  {!this.state.loader ? (
                    <ul className="explore-nfts collection-details">
                      {this.state.createAssetTab1?.length > 0  ? this.state.createAssetTab1.map((explores) => (
                        <li
                          style={{
                            display: this.state.tabId == 3 ? "block" : "none",
                          }}
                        >
                          <Link
                            to={"../NftDetails/?assetId=" + explores.asset_id}
                            className="card"
                          >
                            <div className="card-img">
                              <img src={explores.asset_image} alt="discover" />
                            </div>
                            <div className="card-body">
                              <div className="artist-block">
                                <div className="media">
                                  <div className="media-body">
                                    <div className="media-body__left">
                                      {/* <label>{explores.asset_name}</label> */}
                                      <label
                                        style={{
                                          width: 120 + "px",
                                          whiteSpace: "nowrap",
                                          overflow: " hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        {explores.asset_name}
                                      </label>
                                      {/* <p>FancyBirds</p> */}
                                    </div>
                                    <div className="media-body__right">
                                      {explores.price ? (
                                        <label>
                                          <span>Last</span>{" "}
                                          <img
                                            src={explores.currency_image}
                                            alt="eth"
                                          />{" "}
                                          {explores.price}
                                        </label>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </li>
                      ))
                       :(
                       <>
                      <div className="no-items" style={{display:this.state.tabId ==3 ? "block":"none"}}> 
                         <span>No Items</span>
                         </div>
                     </>)}
                      
                    </ul>
                   
                  ) : (
                    [1].map((loading) => (
                      <>
                        <div className="skeleton-items" key={loading}>
                          <SkeletonProduct />
                        </div>
                      </>
                    ))
                  )}
                  {/* ====================================
                          ACTIVITY
              ==================================== */}
                  {!this.state.loader3 ? (
                    <div
                      className="nft-details__activity w-full"
                      id="test"
                      
                      style={{
                         display: this.state.tabId == 4 ? "block" : "none",
                      }}
                    >
                      {/* <div className="nft-details__activity-header">
                    <h6>Activity</h6>
                  </div> */}
                      <div className="nft-details__activity-table">
                        <Scrollbars className="custmScrollbar">
                       
                        {this.state.createAssetTab1.length > 0 ? (
                          <table width="100%" cellSpacing="7px" cellPadding="0">
                            <thead>
                              <tr>
                                <th>Event</th>
                                <th>Item</th>
                                <th>Price</th>
                                <th>From</th>
                                <th>To</th>
                                <th>Time</th>
                              </tr>
                            </thead>
                            <tbody>
                              { this.state.createAssetTab1?.map(
                                (collectionActivity, i) => (
                                  <tr>
                                    <td>
                                      <i className="material-icons-outlined">
                                        {this.getIcon(
                                          collectionActivity.event_type
                                        )}
                                      </i>
                                      {collectionActivity.event_type}
                                    </td>
                                    <td>
                                      <Link
                                        to={
                                          "../NftDetails/?assetId=" +
                                          collectionActivity.asset_id
                                        }
                                        className="item-img__wrapp link"
                                      >
                                        <div className="item-img">
                                          <img
                                            src={collectionActivity.asset_image}
                                            alt="eth"
                                          />
                                        </div>
                                        {collectionActivity.item}
                                      </Link>
                                    </td>
                                    <td>
                                      {collectionActivity.price ? (
                                        <img
                                          className="prc"
                                          src="../images/eth.png"
                                          alt="eth"
                                        />
                                      ) : (
                                        <></>
                                      )}
                                      {collectionActivity.price}
                                    </td>
                                    <td>
                                      <a
                                        className="link"
                                        href={
                                          "/UserProfile/?account=" +
                                          collectionActivity.from_owner_account
                                        }
                                      >
                                        {collectionActivity.from_owner
                                          ? collectionActivity.from_owner
                                          : collectionActivity.event_type ==
                                            "Minted"
                                          ? "NullAddress"
                                          : "Unnamed"}
                                      </a>
                                    </td>
                                    <td>
                                      <a
                                        className="link"
                                        href={
                                          "/UserProfile/?account=" +
                                          collectionActivity.to_owner_account
                                        }
                                      >
                                        {collectionActivity.to_owner}
                                      </a>
                                    </td>
                                    <td>
                                      {collectionActivity.event_type !==
                                      "List" ? (
                                        <a
                                          target="_blank"
                                          href={this.getTransactionLink(
                                            collectionActivity.chain_id,
                                            collectionActivity.transaction_hash
                                          )}
                                          className="link"
                                        >
                                          {this.getFormattedDateTime(
                                            collectionActivity.time
                                          )}
                                          {"  "}
                                          <i className="material-icons-outlined blue-outline">
                                            open_in_new
                                          </i>
                                        </a>
                                      ) : (
                                        this.getFormattedDateTime(
                                          collectionActivity.time
                                        )
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              
                            </tbody>
                          </table>
                          ) : (
                            <span>No trading history yet</span>
                          )} 
                        </Scrollbars> 
                      </div>
                    </div>
                    ) : (
                    [...Array(5)].map((e, i) => (
                        <Row/>
                    ))
                  )} 
                  
                  {/* <Scrollbars className="custmScrollbar">
                    <div className="filter-box">
                      <div className="filter-title">
                        <h4>Applied Filters</h4>
                        <button className="clear-filter">Clear All</button>
                      </div>
                      <ul className="applied-filter">
                        <li>
                          <span>0.001 ETH - 1 ETH</span>
                          <a href="/">
                            <img
                              src="../images/svg/white-cross.svg"
                              alt="clear filter"
                            />
                          </a>
                        </li>
                       
                        <li>
                          <span>New</span>
                          <a href="/">
                            <img
                              src="../images/svg/white-cross.svg"
                              alt="clear filter"
                            />
                          </a>
                        </li>
                       
                        <li>
                          <span>On Action</span>
                          <a href="/">
                            <img
                              src="../images/svg/white-cross.svg"
                              alt="clear filter"
                            />
                          </a>
                        </li>
                       
                        <li>
                          <span>Has Offers</span>
                          <a href="/">
                            <img
                              src="../images/svg/white-cross.svg"
                              alt="clear filter"
                            />
                          </a>
                        </li>
                        
                      </ul>
                      <div className="filter-title">
                        <h4>Status</h4>
                      </div>
                      <ul className="filter-check-list">
                        <li>
                          <label htmlFor="buyNow">
                            <input
                              type="checkbox"
                              id="buyNow"
                              hidden
                              defaultChecked
                            />
                            <div className="img-box">
                              <img
                                src="../images/svg/check-white.svg"
                                alt="check"
                              />
                            </div>
                            <span>Buy Now</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="onAuction">
                            <input
                              type="checkbox"
                              id="onAuction"
                              hidden
                              defaultChecked
                            />
                            <div className="img-box">
                              <img
                                src="../images/svg/check-white.svg"
                                alt="check"
                              />
                            </div>
                            <span>On Auction</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="new">
                            <input
                              type="checkbox"
                              id="new"
                              hidden
                              defaultChecked
                            />
                            <div className="img-box">
                              <img
                                src="../images/svg/check-white.svg"
                                alt="check"
                              />
                            </div>
                            <span>New</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="hasOffer">
                            <input
                              type="checkbox"
                              id="hasOffer"
                              hidden
                              defaultChecked
                            />
                            <div className="img-box">
                              <img
                                src="../images/svg/check-white.svg"
                                alt="check"
                              />
                            </div>
                            <span>Has Offer</span>
                          </label>
                        </li>
                      </ul>
                      <div className="filter-title">
                        <h4>Price (in ETH)</h4>
                      </div>
                      <div className="price-range">
                        <input
                          type="text"
                          name="min"
                          id="min"
                          placeholder="min"
                          className="min"
                        />
                        <span>to</span>
                        <input
                          type="text"
                          name="max"
                          id="max"
                          placeholder="max"
                          className="max"
                        />
                      </div>
                      <div className="filter-title">
                        <h4>Blockchains</h4>
                      </div>
                      <ul className="filter-check-list">
                        <li>
                          <label htmlFor="ethereum">
                            <input
                              type="checkbox"
                              id="ethereum"
                              hidden
                              defaultChecked
                            />
                            <div className="img-box">
                              <img
                                src="../images/svg/check-white.svg"
                                alt="check"
                              />
                            </div>
                            <div className="icon">
                              <img src="../images/coin/eth.png" alt="Verify" />
                            </div>
                            <span>Ethereum</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="polygon">
                            <input
                              type="checkbox"
                              id="polygon"
                              hidden
                              defaultChecked
                            />
                            <div className="img-box">
                              <img
                                src="../images/svg/check-white.svg"
                                alt="check"
                              />
                            </div>
                            <div className="icon">
                              <img src="../images/coin/poly.png" alt="Verify" />
                            </div>
                            <span>Polygon</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="solana">
                            <input
                              type="checkbox"
                              id="solana"
                              hidden
                              defaultChecked
                            />
                            <div className="img-box">
                              <img
                                src="../images/svg/check-white.svg"
                                alt="check"
                              />
                            </div>
                            <div className="icon">
                              <img src="../images/coin/sola.png" alt="Verify" />
                            </div>
                            <span>Solana</span>
                          </label>
                        </li>
                      </ul>
                      <div className="filter-title">
                        <h4>Verification</h4>
                      </div>
                      <ul className="filter-check-list">
                        <li>
                          <label htmlFor="verified">
                            <input
                              type="checkbox"
                              id="verified"
                              hidden
                              defaultChecked
                            />
                            <div className="img-box">
                              <img
                                src="../images/svg/check-white.svg"
                                alt="check"
                              />
                            </div>
                            <div className="icon">
                              <img src="../images/verify.png" alt="Verify" />
                            </div>
                            <span>Show only verified</span>
                          </label>
                        </li>
                      </ul>
                      <div className="filter-btn-wrap">
                        <button className="button">Apply</button>
                        <button className="button purple-outline">
                          Cancel
                        </button>
                      </div>
                    </div>
                  </Scrollbars> */}
                </div>
                {/* <div className="button-wrap">
              <a href="/" className="button purple-outline">
                Show More
              </a>
            </div> */}
              </div>
            </div>
          </section>
        </div>
        <Footer />
      </>
    );
  };
}
